import type { QueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { previewContentPageQueryOptions, type PreviewContentSearch } from "~/app/api/pageData/previewContentPageQuery";
import { unwrapPageInitialData } from "~/app/api/pageData/pageInitialDataLoader";

function PreviewContentRoute() {
  return null;
}

export async function loadPreviewContentPageData(context: { queryClient: QueryClient }, search: PreviewContentSearch) {
  const result = await context.queryClient.ensureQueryData(previewContentPageQueryOptions(search));
  return unwrapPageInitialData(result);
}

export const Route = createFileRoute("/preview-content")({
  validateSearch: (search: Record<string, unknown>): PreviewContentSearch => ({
    uid: typeof search.uid === "string" ? search.uid : undefined,
    cmsTicketId: typeof search.cmsTicketId === "string" ? search.cmsTicketId : undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => loadPreviewContentPageData(context, deps),
  component: PreviewContentRoute,
});
